// @ts-nocheck
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useI18n } from './index';
export default function() {
    function withI18n(InputComponent) {
        const I18nWrapper = /*#__PURE__*/ forwardRef((props, ref)=>{
            const i18n = useI18n();
            return /*#__PURE__*/ _jsx(InputComponent, {
                ...props,
                i18n: i18n,
                ref: ref
            });
        });
        const name = InputComponent.displayName || InputComponent.name;
        I18nWrapper.displayName = `withI18n(${name})`;
        return I18nWrapper;
    }
    return withI18n;
}
